function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M77.426 2.614c-8.822 25.279-16.292 129.675 20.459 117.84 36.751-11.836 50.687-57.15 19.67-62.01-32.423-5.08-110.124 50.627-51.736 92.243 52.663 37.535 98.652 9.552 105 9.501 44.149-7.372 92.461-7.489 76.339 42.974-16.122 50.463-73.631 106.984-100.37 128.937",
  stroke: "#A3A3A3",
  strokeWidth: 2.979
});

var SvgSquiggle4 = function SvgSquiggle4(props) {
  return React.createElement("svg", _extends({
    width: 285,
    height: 349,
    viewBox: "0 0 285 349",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg1IiBoZWlnaHQ9IjM0OSIgdmlld0JveD0iMCAwIDI4NSAzNDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMyIgZD0iTTc3LjQyNTggMi42MTM3NkM2OC42MDM2IDI3Ljg5MjcgNjEuMTMzNiAxMzIuMjg5IDk3Ljg4NDUgMTIwLjQ1NEMxMzQuNjM2IDEwOC42MTggMTQ4LjU3MiA2My4zMDM0IDExNy41NTUgNTguNDQzNkM4NS4xMzIzIDUzLjM2MzQgNy40MzA3NiAxMDkuMDcxIDY1LjgxOTEgMTUwLjY4N0MxMTguNDgyIDE4OC4yMjIgMTY0LjQ3MSAxNjAuMjM5IDE3MC44MTkgMTYwLjE4OEMyMTQuOTY4IDE1Mi44MTYgMjYzLjI4IDE1Mi42OTkgMjQ3LjE1OCAyMDMuMTYyQzIzMS4wMzYgMjUzLjYyNSAxNzMuNTI3IDMxMC4xNDYgMTQ2Ljc4OCAzMzIuMDk5IiBzdHJva2U9IiNBM0EzQTMiIHN0cm9rZS13aWR0aD0iMi45NzkwNiIvPgo8L3N2Zz4K";
export { SvgSquiggle4 as ReactComponent };